import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

const json = () => authHeaders({ "Content-Type": "application/json" });

const getAll = async () => (await axios.get(`${API_URL}policies`, { headers: authHeaders() })).data;
const create = async (data) => (await axios.post(`${API_URL}policies/create`, data, { headers: json() })).data;
// data must include 'id'
const update = async (data) => (await axios.post(`${API_URL}policies/update`, data, { headers: json() })).data;
const remove = async (id) => (await axios.post(`${API_URL}policies/delete`, { id }, { headers: json() })).data;

export default { getAll, create, update, remove };